import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

class TimeZonesDAO {

    static async getList(
      filters?: {
        pattern?: string | null
      }
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest('timeZones.getList', filters);
    }

    static async get(id: string): Promise<RpcResponse> {
        return await RpcService.makeRequest('timeZones.get', {
            id,
        });
    }
}

export default TimeZonesDAO;
